import { render } from "./CardBoxComponentForbidden.vue?vue&type=template&id=7972b051"
const script = {}

import exportComponent from "C:\\xampp\\htdocs\\unensedu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__